import createAction from './create-action';
import ApiService from '../../services/api-service';
import { Dispatch } from 'redux';

/**
 * ACTION TYPES
 */
export const EXPERIENCE_GET = 'experience:get';

/**
 * THUNKS
 */

export const resetExperience = () => (dispatch: Dispatch) => dispatch(createAction(`${EXPERIENCE_GET}:reset`));

export const getExperience = (experienceId: string | number) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(EXPERIENCE_GET, ApiService.getExperience(experienceId), {
      __PARSABLE__: true,
    })
  );
};

export const resetLiveTourExperience = () => (dispatch: Dispatch) => dispatch(createAction(`${EXPERIENCE_GET}:reset`));

export const getLiveTourExperience = (experienceId: string | number) => (dispatch: Dispatch) => {
  return dispatch(
    createAction(EXPERIENCE_GET, ApiService.getLiveTourExperience(experienceId), {
      __PARSABLE__: true,
    })
  );
};
